import React from 'react';
import { ChevronRightIcon, DownloadIcon, FileTextIcon, LeafIcon, PackageIcon, RecycleIcon, Share2Icon, SparklesIcon, SproutIcon, Trash2Icon } from 'lucide-react';
import { categories, collectionsByDate, formatLongDate, toKey, type CategoryId } from '../../data/calendrierCollectes';
const icons: Record<CategoryId, typeof RecycleIcon> = {
  recyclage: RecycleIcon,
  dechets: Trash2Icon,
  organiques: LeafIcon,
  jardin: SproutIcon,
  lourds: PackageIcon,
  speciales: SparklesIcon
};
interface DayDetailsProps {
  date: Date;
}
export function DayDetails({
  date
}: DayDetailsProps) {
  const events = collectionsByDate[toKey(date)] ?? [];
  return <section aria-live="polite" aria-labelledby="jour-titre" data-id="element-787" data-mp="65t7dwgl3cwy">
      <h2 id="jour-titre" className="text-2xl font-extrabold tracking-tight text-ville-navy" data-id="element-788" data-mp="648e0a60a00o">
        {formatLongDate(date)}
      </h2>

      {events.length === 0 ? <p className="mt-4 rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-5 py-6 text-sm text-slate-500" data-id="element-789" data-mp="2qxd8ps87iyvu">
          Aucune collecte prévue à votre adresse cette journée.
        </p> : <ul className="mt-4 space-y-3" data-id="element-790" data-mp="2jt3gh776h5sw">
          {events.map(id => {
        const category = categories[id];
        const Icon = icons[id];
        return <li key={id} data-id="element-791" data-mp="2sr5pa8x5l2qq">
                <button type="button" className="flex w-full items-center gap-4 rounded-2xl border border-slate-200 bg-white px-5 py-4 text-left transition-colors duration-150 ease-ville hover:border-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-792" data-mp="2sqvxqgwgmnix">
                  <span className={`grid h-11 w-11 shrink-0 place-items-center rounded-xl ${category.chip}`} aria-hidden="true" data-id="element-793" data-mp="3cgg5do0t9ppd">
                    <Icon className="h-5 w-5" data-id="element-794" data-mp="3qh0oklan1nje" />
                  </span>
                  <span className="min-w-0 flex-1" data-id="element-795" data-mp="3lh4k6ky13u3b">
                    <span className="block font-bold uppercase tracking-wide text-ville-navy" data-id="element-796" data-mp="3lipec9gflb0n">{category.label}</span>
                    <span className="block text-sm text-slate-500" data-id="element-797" data-mp="2j1di6zhzqb3s">{category.time}</span>
                  </span>
                  <ChevronRightIcon className="h-5 w-5 shrink-0 text-slate-400" aria-hidden="true" data-id="element-798" data-mp="2s44t8y6yf4uw" />
                </button>
              </li>;
      })}
        </ul>}

      <div className="mt-6 grid grid-cols-3 divide-x divide-slate-100 overflow-hidden rounded-3xl border border-slate-200 bg-white" data-id="element-799" data-mp="2wwpl3u6av7vs">
        {[{
        label: 'PDF',
        Icon: FileTextIcon
      }, {
        label: 'Télécharger',
        Icon: DownloadIcon
      }, {
        label: 'Partager',
        Icon: Share2Icon
      }].map(({
        label,
        Icon
      }) => <button key={label} type="button" className="flex flex-col items-center gap-1.5 px-2 py-4 text-xs font-bold text-ville-navy transition-colors duration-150 ease-ville hover:bg-ville-sand hover:text-ville-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-800" data-mp="3ftz5pend2rem">
            <span className="grid h-10 w-10 place-items-center rounded-full bg-ville-mist text-ville-deep" aria-hidden="true" data-id="element-801" data-mp="1dxhwtgfxpsxl">
              <Icon className="h-5 w-5" data-id="element-802" data-mp="147f5rlsdip1w" />
            </span>
            {label}
          </button>)}
      </div>
    </section>;
}